import React from 'react';
import Modal from '@material-ui/core/Modal';
import {
  Box,
  Button,
  makeStyles,
  Typography,
  IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close'; // import close icon
import { usePermissions } from 'src/hooks';

const useStyles = makeStyles((theme) => ({
  body: {
    position: 'absolute',
    width: '100%',
    maxWidth: 500,
    maxHeight: '90vh',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(3),
    borderRadius: 8,
    top: '30%',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
      width: '95%'
    }
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  footer: {
    marginTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      '& button': {
        width: '100%',
        marginLeft: 0
      }
    }
  },
  formContainer: {
    marginTop: theme.spacing(3)
  },
  footerBtn: {
    minWidth: 150,
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%'
    }
  },
  closeButton: {
    padding: 0,
    marginLeft: theme.spacing(2)
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3)
  }
}));
interface Props {
  item?: string;
  title?: string;
  visible: boolean;
  loading?: boolean;
  contentText?: string;
  onHandleClose: () => void;
  onConfirm: (recompute: boolean) => void;
}

export const ConfirmationModal = ({
  visible,
  onHandleClose,
  title,
  contentText,
  item,
  onConfirm
}: Props) => {
  const classes = useStyles();
  const { canDeleteTransactionPayment } = usePermissions();

  return (
    <Modal
      disableBackdropClick
      open={visible}
      onClose={onHandleClose}
      className={classes.modal}
    >
      <div className={classes.body}>
        {title ? (
          <div className={classes.titleContainer}>
            <Typography variant="h4" color="textPrimary">
              {title}
            </Typography>
            <IconButton
              onClick={onHandleClose}
              className={classes.closeButton}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </div>
        ) : null}

        {contentText ? (
          <div className={classes.formContainer}>
            <Typography
              variant="body1"
              color="textSecondary"
              style={{ whiteSpace: 'pre-line' }}
            >
              {contentText}
            </Typography>
          </div>
        ) : null}

        <Box className={classes.footer}>
          <Button
            color="secondary"
            variant="text"
            onClick={() => {
              onConfirm(true);
              onHandleClose();
            }}
            className={classes.footerBtn}
            disabled={!canDeleteTransactionPayment}
          >
            Update as bundle
          </Button>
          <Button
            className={classes.footerBtn}
            onClick={() => {
              onConfirm(false);
              onHandleClose();
            }}
            color="primary"
            variant="text"
          >
            Update {item} only
          </Button>
        </Box>
      </div>
    </Modal>
  );
};
